<!--系统管理页面弹窗组件  :rules="rules"-->
<template>
  <el-dialog
    title="添加普通工单信息"
    :visible="show"
    width="80%"
    @close="closeWindow"
    class="dialog_container"
  >
    <div style="height: 30px">政府援助工单信息-客户信息</div>
    <div class="add-ent">
      <div>
        <div class="add-title1">
          <div>客户姓名：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>联系方式一：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>联系地址：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>主要服务人员：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>从属服务人员一：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>从属服务人员二：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>志愿者：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>开始服务时间：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>服务时长：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
      </div>
      <div>
        <div class="add-title1">
          <div>联系人：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>联系方式二：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>服务对象类型：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>服务人员电话：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>免费订单：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>志愿者电话：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>结束服务时间：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>区域名称：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 30px">政府援助工单信息-客户信息</div>

    <div class="add-ent">
      <div>
        <div class="add-title1">
          <div>服务种类：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>计划时间：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
      </div>
      <div>
        <div class="add-title1">
          <div>服务产品：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>频次：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
      </div>
    </div>

    <div class="add-title1">
      <div>产品说明：</div>
      <div>
        <el-input size="medium" type="textarea"></el-input>
      </div>
    </div>
    <div class="add-title1">
      <div>服务要求：</div>
      <div>
        <el-input size="medium" type="textarea"></el-input>
      </div>
    </div>

    <div style="height: 30px">政府援助工单信息-机构信息</div>

    <div class="add-ent">
      <div>
        <div class="add-title1">
          <div>机构：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>主要服务人员：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>从属服务人员一：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>从属服务人员二：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>志愿者：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
      </div>
      <div>
        <div class="add-title1">
          <div>加盟商：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>加盟商主要服务人员：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>加盟商从属服务人员：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
      </div>
    </div>

    <div style="height: 30px">政府援助工单信息-服务坐席</div>

    <div class="add-ent">
      <div>
        <div class="add-title1">
          <div>新建工单人：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>派发工单人：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>服务开始：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>处理工单人：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>申请作废人：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>作废工单人：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>回访工单人：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
      </div>
      <div>
        <div class="add-title1">
          <div>新建工单：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>派发工单：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>服务结束：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>处理工单：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>申请作废：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>作废工单：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
        <div class="add-title1">
          <div>回访工单：</div>
          <div>
            <el-input size="medium"></el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="add-title1">
      <div>APP用户反馈：</div>
      <div>
        <el-input size="medium"></el-input>
      </div>
    </div>

    <div class="add-title2">
      <div>选择图片：</div>
      <div>
        <div>
          <div>
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="gongzuo">工作开始</div>
        </div>
        <div>
          <div>
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="gongzuo">工作结束</div>
        </div>
      </div>
    </div>

    <div class="btn">
      <div>
        <el-button type="primary" @click="send">保存</el-button>
        <el-button @click="closeWindow">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import request from "@/utils/request.js"

export default {
  name: "AddEntity",
  props: {
    showEntity: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageUrl: "",
    }
  },
  computed: {
    show() {
      return this.showEntity
    },
  },
  created() {},
  methods: {
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {},
    send() {
      this.closeWindow()
    },
    closeWindow() {
      this.$emit("update:showEntity", false)
      this.serverObj = {}
    },
  },
}
</script>
<style lang="less" scoped>
.dialog_container {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e5e5e5;
  }
}

.btn {
  width: 100%;
  display: flex;
  justify-content: center;
}

.add-ent {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.add-ent > div {
  width: 48%;
}

.add-title1 {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.add-title1 > div:first-child {
  width: 120px;
  text-align: right;
}

.add-title1 > div:nth-child(2) {
  width: calc(100% - 120px);
}

.add-title2 {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
}

.add-title2 > div:first-child {
  width: 120px;
  text-align: right;
}

.add-title2 > div:nth-child(2) {
  width: 40%;
  display: flex;
  justify-content: space-between;
}

.gongzuo {
  width: 178px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}
</style>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
